import { z } from 'zod';
import { ACOES, type AcaoDeAuditoria } from './acoes';

/**
 * Filtros da auditoria na URL (spec 016, CA-01), iguais nas duas rotas (academia e plataforma).
 * Valor inválido na URL cai fora em vez de quebrar a tela.
 */
export const buscaDaAuditoria = z.object({
  acao: z
    .enum(ACOES as [AcaoDeAuditoria, ...AcaoDeAuditoria[]])
    .optional()
    .catch(undefined),
  atorId: z.uuid().optional().catch(undefined),
  de: z.iso.date().optional().catch(undefined),
  ate: z.iso.date().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});
